export const stepColors = {
  active: '#9F5255',
  incomplete: '#E5E7EB',
  success: '#68B984',
};
